// extracted by mini-css-extract-plugin
module.exports = {"subTable":"NestedItemsTable-module__subTable___XWlwF"};